var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9059 4.36849C17.2301 4.36849 17.5 4.63765 17.5 4.98015V5.29681C17.5 5.63098 17.2301 5.90847 16.9059 5.90847H3.09488C2.76988 5.90847 2.5 5.63098 2.5 5.29681V4.98015C2.5 4.63765 2.76988 4.36849 3.09488 4.36849H5.52464C6.01821 4.36849 6.44775 4.01766 6.55879 3.52266L6.68603 2.95434C6.88378 2.18018 7.53458 1.66602 8.27939 1.66602H11.7206C12.4573 1.66602 13.1154 2.18018 13.3059 2.9135L13.442 3.52183C13.5522 4.01766 13.9818 4.36849 14.4762 4.36849H16.9059ZM15.6715 15.9444C15.9252 13.5802 16.3693 7.96362 16.3693 7.90695C16.3855 7.73529 16.3296 7.57279 16.2186 7.44196C16.0994 7.31946 15.9487 7.24696 15.7826 7.24696H4.22377C4.05681 7.24696 3.89796 7.31946 3.78774 7.44196C3.6759 7.57279 3.62079 7.73529 3.62889 7.90695C3.63038 7.91737 3.64632 8.11521 3.67296 8.44597C3.79132 9.91534 4.12097 14.0078 4.33399 15.9444C4.48474 17.371 5.42082 18.2677 6.77672 18.3002C7.82302 18.3244 8.90094 18.3327 10.0032 18.3327C11.0414 18.3327 12.0958 18.3244 13.1745 18.3002C14.5774 18.276 15.5127 17.3952 15.6715 15.9444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon2);
export default __webpack_public_path__ + "static/media/delete-icon-2.84f67631df46047b1b0db97e54ea6bc7.svg";
export { ForwardRef as ReactComponent };